import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import Layout from '../../components/Layout';
import Carousel from "../../components/CarouselWrapper";
import queryString from 'query-string';
import { 
  UI_NONE, 
  DEFAULT_THEME,
} from "../../constants";
import _findIndex from 'lodash/findIndex';
import API from '../../functions/api';
import cn from "classnames";
import "./serviceplanprice.scss";

const modelOrder = [
  // {main: "etron", other: ["etrons"], plans: ["sixYearServicePlan"]},
  {main: "etrongt", other: ["rsetrongt"], plans: ["sixYearServicePlan"]},
  {main: "a1", other: ["s1"], plans: ["fiveYearServicePlan", "audiAdvantage"]},
  {main: "a3", other: ["s3", "rs3"], plans: ["fiveYearServicePlan", "audiAdvantage"]},
  {main: "a4", other: ["s4", "rs4"], plans: ["fiveYearServicePlan", "audiAdvantage"]},
  {main: "a5", other: ["s5", "rs5"], plans: ["fiveYearServicePlan", "audiAdvantage"]},
  {main: "a6", other: ["s6", "rs6"], plans: ["fiveYearServicePlan", "audiAdvantage"]},
  {main: "a7", other: ["s7", "rs7"], plans: ["fiveYearServicePlan", "audiAdvantage"]},
  {main: "a8", other: ["s8"], plans: ["fiveYearServicePlan", "audiAdvantage"]},
  {main: "q2", other: ["sq2"], plans: ["fiveYearServicePlan", "audiAdvantage"]},
  {main: "q3", other: ["rsq3"], plans: ["fiveYearServicePlan", "audiAdvantage"]},
  {main: "q4", plans: ["fiveYearServicePlan", "audiAdvantage"]},
  {main: "q4etron", plans: ["sixYearServicePlan"]},
  {main: "q5", other: ["sq5"], plans: ["fiveYearServicePlan", "audiAdvantage"]},
  {main: "q6etron", other: ["sq6etron"], plans: ["sixYearServicePlan"]},
  {main: "q7", other: ["sq7"], plans: ["fiveYearServicePlan", "audiAdvantage"]},
  {main: "q8", other: ["sq8", "rsq8"], plans: ["fiveYearServicePlan", "audiAdvantage"]},
  {main: "q8etron", plans: ["sixYearServicePlan"]},
  {main: "tt", other: ["tts", "ttrs"], plans: ["fiveYearServicePlan", "audiAdvantage"]}
];

const planLabels = {
  "fiveYearServicePlan": "5 Year Service Plan",
  "sixYearServicePlan": "6 Year Service Plan",
  "audiAdvantage": "Audi Advantage"
};

const ServicePlanPrice = ({ location }) => {

  const query = queryString.parse(location.search);

  // const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [initialSlideIdx, setInitialSlideIdx] = useState(null);
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedOther, setSelectedOther] = useState([]);
  const [selectedPlans, setSelectedPlans] = useState([]);

  const handleModelChange = (mo) => {
    setSelectedModel(mo.main);
    setSelectedOther(mo.other);
    setSelectedPlans(mo.plans);
  }

  const getData = (list = []) => {
    API.post(
      `${process.env.RAZZLE_GQLAPI}`,
      {
          query: /* GraphQL */`query ($filter: ServicePricingDtoFilterInput) {
            servicePricingList(where: $filter, take: 50) {
              items {
                servicePricingId
                name
                status
                jsonData
                smallImageUrl
                smallActiveImageUrl
              }
              totalCount
            }
          }`,
          variables: {
            filter: {status: {eq: true}}
          }
      }
    ).then((response) => {
      if (response.data.errors) {
        //
      } else if (response.data.data?.servicePricingList?.items) {
        let newList = [...list, ...response.data.data.servicePricingList.items];
        if (newList.length < response.data.data.servicePricingList.totalCount) {
          // load more
          getData(newList);
        } else {
          // got all
          let modelObj = {};
          for (let i=0; i<newList.length; i++) {
            let m = newList[i];
            m.engineTypes = m.jsonData ? JSON.parse(m.jsonData) : [];
            let key = m.name.replace('é','e').replace(/[^a-z0-9]/gi,'').toLowerCase();
            modelObj[key] = m;
          }
          let moIdx = null;
          if (query.selected) {
            let s = query.selected.replace('é','e').replace(/[^a-z0-9]/gi,'').toLowerCase();
            moIdx = _findIndex(modelOrder, {main: s});
            handleModelChange(modelOrder[moIdx]);
          }
          setData(modelObj);
          setInitialSlideIdx(moIdx);
        }
      }
    }).catch((error) => {
      console.error(error);
    });
  }
  
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return (
    <Layout ui={query.ui || UI_NONE} embedded theme={query.theme}>
      <Helmet>
        <title>Service Plan Pricing | Audi Australia</title>
      </Helmet>
      <main className="audi-forms__page service-plan-price">
        {data && Object.keys(data).length > 0 && <>
          <Carousel as="ul" className="modelband" showButtons options={{ slidesToScroll: 'auto' }} initialSlideIdx={initialSlideIdx}>
            {modelOrder.map((mo,i) => {
              let model = data[mo.main];
              if (!model || typeof model === "undefined") { return null; }
              let img = model?.smallImageUrl?.replace("http://", "https://");
              if (!img) { return null; }
              let activeImg = model?.smallActiveImageUrl?.replace("http://", "https://") || img;
              return (
                <li key={mo.main} className={cn("modelband__item", {"active": selectedModel === mo.main})}>
                  <button type="button" onClick={()=>{ handleModelChange(mo); }}>
                    <img src={img} alt="" className="modelband__img" />
                    <img src={activeImg} alt="" className="modelband__img-active" />
                    <span>{model.name}</span>
                  </button>
                </li>
              );
            })}
          </Carousel>
          
          {selectedModel && <div className="detail pt-3">
            <div className="aui-table aui-table--stretched">
              <table>
                <thead>
                  <tr>
                    <th><p className="aui-headline-4">{data[selectedModel].name}</p></th>
                    {selectedPlans.map(plan => {
                      return (<th key={plan} style={{width: `${74 / selectedPlans.length}%`}}>{planLabels[plan]}</th>)
                    })}
                  </tr>
                </thead>
                <tbody>
                  {data[selectedModel].engineTypes?.map((eng,i) => {
                    return (<tr key={`eng${i}`}>
                      <td>{eng.engineType}</td>
                      {selectedPlans.map(plan => {
                        return (<td key={plan}>{eng[plan]}</td>)
                      })}
                    </tr>);
                  })}
                </tbody>
              </table>
            </div>
          </div>}
          
          {selectedOther?.length > 0 && selectedOther.map((other) => {
            if (!data[other]) { return null; }
            return (<div className="detail pt-3" key={`other${other}`}>
              <div className="aui-table aui-table--stretched">
                <table>
                  <thead>
                    <tr>
                      <td><p className="aui-headline-4">{data[other].name}</p></td>
                      {selectedPlans.map(plan => {
                        return (<td key={plan} style={{width: `${74 / selectedPlans.length}%`}}><span className="visually-hidden">{planLabels[plan]}</span></td>)
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {data[other].engineTypes?.map((eng,i) => {
                      return (<tr key={`eng${i}`}>
                        <td>{eng.engineType}</td>
                        {selectedPlans.map(plan => {
                          return (<td key={plan}>{eng[plan]}</td>)
                        })}
                      </tr>);
                    })}
                  </tbody>
                </table>
              </div>
            </div>);
          })}
        </>}
      </main>
    </Layout>
  );
}

export default ServicePlanPrice;
